import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import {
  Router,
  ActivatedRoute,
  NavigationEnd,
  UrlSegment
} from "@angular/router";
// import { routerTransition } from "./animation/animation.component";
import "rxjs/add/operator/filter";
import "rxjs/add/operator/map";
import "rxjs/add/operator/mergeMap";
import { MessageService } from "./core/services/message.service";
import { Message } from "primeng/primeng";

import { UserInfoComponent } from './user-info/user-info.component';
// import { LoginRegisterComponent } from './user-info/login-register/login-register.component';
// enableProdMode();

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  // animations: [routerTransition]
})
export class AppComponent implements OnInit {
  showHeader: boolean = true;
  singlePage = [UserInfoComponent];
  // singlePage = [];
  @ViewChild('o') otl;
  title = "app";
  msg: Message[] = [];
  isHidden = false;
  constructor(private _msgService: MessageService, private _ar: ActivatedRoute) {
    this._msgService.message$.subscribe(message => {
      if (message) {
        this.msg.push(message);
      } else {
        this.msg = [];
      }
    });
  }

  ngOnInit() {
    // let tmp = this._ar.snapshot.component;
  }
  onActivate(event) {
    this.singlePage.find(rec => {
      if (event instanceof rec) {
        this.showHeader = false;
        return true;
      } else {
        this.showHeader = true;
        return false;
      }
    });
    // (event instanceof LoginRegisterComponent) && (this.showHeader = false);
    // this.otl.activatedRoute.url.subscribe((activeUrl: UrlSegment[])=>{
    //   console.log(activeUrl);
    // });

  }
  getState(outlet) {
    return outlet.activatedRouteData.state;
  }
  showMessage() { }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/app.component.ts